var map = {
	"./account-ico-mail.svg": 810,
	"./account-ico-pass.svg": 811,
	"./account-ico-phone.svg": 812,
	"./bank-transfer.svg": 813,
	"./betnearn-ico.svg": 814,
	"./birthday-bonus-ico.svg": 815,
	"./bonus-code-ico.svg": 816,
	"./bonus-ico.svg": 817,
	"./bonus-received-ico.svg": 818,
	"./business-account-upgrade-ico.svg": 819,
	"./check-in-daily-ico.svg": 820,
	"./checked.svg": 821,
	"./cloud-pointer.svg": 822,
	"./crypto.svg": 823,
	"./daily-bonus-ico.svg": 824,
	"./deposit-delay-bonus-ico.svg": 825,
	"./e-wallet.svg": 826,
	"./earn-coin-ico.svg": 827,
	"./earn-x33-coin-ico.svg": 828,
	"./email.svg": 829,
	"./facebook.svg": 830,
	"./feedback.svg": 831,
	"./first-bet-ico.svg": 832,
	"./games-rebate-ico.svg": 833,
	"./info.svg": 834,
	"./instagram.svg": 835,
	"./instant-rebate.svg": 836,
	"./live-casino-rebate-ico.svg": 837,
	"./lucky-spin-ico.svg": 838,
	"./messenger.svg": 839,
	"./mobile-app-deposit-ico.svg": 840,
	"./msg-activity.svg": 841,
	"./msg-ann.svg": 842,
	"./msg-notice.svg": 843,
	"./new-icon.svg": 844,
	"./people-ico.svg": 845,
	"./quick-pay.svg": 846,
	"./r77-coin.svg": 847,
	"./rescue-bonus-ico.svg": 848,
	"./rescue-lc-ico.svg": 849,
	"./rescue-slots-ico.svg": 850,
	"./return.svg": 851,
	"./sc-bc-active-ico.svg": 852,
	"./sc-bc-ico.svg": 853,
	"./sc-bi-active-ico.svg": 854,
	"./sc-bi-ico.svg": 855,
	"./sc-mail-active-ico.svg": 856,
	"./sc-mail-ico.svg": 857,
	"./sc-mp-active-ico.svg": 858,
	"./sc-mp-ico.svg": 859,
	"./sc-pin-active-ico.svg": 860,
	"./sc-pin-ico.svg": 861,
	"./slots-rebate-ico.svg": 862,
	"./sports-rebate-ico.svg": 863,
	"./telegram.svg": 864,
	"./twitter.svg": 865,
	"./vip-up-level-ico.svg": 866,
	"./vip-weekly-bonus.svg": 867,
	"./wallet-ico.svg": 868,
	"./weekly-tournament-ico.svg": 869,
	"./welcome-bonus-ico.svg": 870,
	"./whatsapp.svg": 871,
	"./withdrawal-delay-bonus-ico.svg": 872,
	"./x33-coin.svg": 873
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64;